import { render, staticRenderFns } from "./CompanySaleOffers.vue?vue&type=template&id=07080d73&"
import script from "./CompanySaleOffers.vue?vue&type=script&lang=js&"
export * from "./CompanySaleOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports